import { ActivityFeedFragment } from 'services/apollo';
import gql from 'graphql-tag';

export const HomeActivityFeedQuery = gql`
  query getHomeActivityFeed($first: Int!, $cursor: String!, $includeGroups: Boolean!) {
    me {
      activityFeed(first: $first, cursor: $cursor, includeGroups: $includeGroups) {
        ...activityFeedResults
      }
    }
  }
  ${ActivityFeedFragment}
`;
